import { application, loadStimulusDefinitionsFromContexts } from "../../lib/stimulus";
import { PrintButtonController } from "stimulus-library";

loadStimulusDefinitionsFromContexts(application, require.context(".", true, /_controller\.js$/));

application.register("print-button", PrintButtonController);